import UpdateActivityPopup from "views/components/Schedules/components/UpdateActivityPopup";
import SpaceScheduleActivityCard from "../ScheduleActivities/components/SpaceScheduleActivityCard";
import DialogConfirmExitWithoutSaving from "../Dialogs/DialogConfirmExitWithoutSaving";

const ScheduleActivity = ({
	header, reservation,
	quantityCells = 4,
	classList = [],
	$activity, updateActivityPopup,
	children
}) => {
	const { dialogConfirmExitWithoutSaving } = updateActivityPopup;
	if (quantityCells < 4)
		classList.push("less-than-one-hour");
	return (
		<td rowSpan={quantityCells}>
			<UpdateActivityPopup
				updateActivityPopup={updateActivityPopup}
				confirmExitFromDialog={dialogConfirmExitWithoutSaving.open}
				mustConfirm={updateActivityPopup.mustConfirm.value}>
				{reservation && children}
			</UpdateActivityPopup>
			<SpaceScheduleActivityCard
				header={header}
				classList={classList}
				$activity={$activity}
				reservation={reservation}
				updateActivityPopup={updateActivityPopup}
				quantityCells={quantityCells} />
			<DialogConfirmExitWithoutSaving
				dialog={dialogConfirmExitWithoutSaving}
				updateActivityPopup={updateActivityPopup} />
		</td>
	);
}

export default ScheduleActivity;